import React from 'react';
import { Link } from 'react-router-dom';

interface GameCardProps {
  id: number;
  name: string;
  description: string;
  thumbnail: string;
  category: string;
}

const GameCard: React.FC<GameCardProps> = ({ id, name, description, thumbnail, category }) => {
  // Fallback image for broken thumbnails
  const fallbackImage = '/images/placeholder.jpg';
  
  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    e.currentTarget.src = fallbackImage;
  };
  
  return (
    <Link to={`/game/${id}`} className="block">
      <div className="card h-full flex flex-col">
        <div className="relative aspect-video overflow-hidden bg-gray-800">
          <img
            src={process.env.PUBLIC_URL + thumbnail}
            alt={name}
            className="w-full h-full object-cover transform transition-transform duration-300 hover:scale-105"
            onError={handleImageError}
          />
          <div className="absolute top-2 right-2 bg-primary text-white text-xs px-2 py-1 rounded">
            {category}
          </div>
        </div>
        <div className="p-4 flex-grow flex flex-col">
          <h3 className="text-lg text-white font-medium mb-2">{name}</h3>
          <p className="text-gray-400 text-sm mb-4 line-clamp-2 flex-grow">
            {description}
          </p>
          <div className="mt-auto">
            <span className="inline-block text-xs bg-dark text-primary px-2 py-1 rounded-full">
              Play Now
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default GameCard; 